<template>
    <ConfirmDialog group="headless">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
                <div
                    class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
                    <i class="pi pi-question text-5xl"></i>
                </div>
                <span class="font-bold text-2xl block mb-2 mt-6">{{
                    message.header
                    }}</span>
                <p class="mb-0">{{ message.message }}</p>
                <div class="flex items-center gap-2 mt-6">
                    <Button label="Save" @click="acceptCallback" class="w-32"></Button>
                    <Button label="Cancel" outlined @click="rejectCallback" class="w-32"></Button>
                </div>
            </div>
        </template>
    </ConfirmDialog>
    <ModalChooseCashRegister v-if="modalShowCashRegister" @closeModal="closeModalCashRegister"
        @selectCashRegister="selectCashRegister" />
    <section
        class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
        <div id="modal modal-customer"
            class="modal relative block bg-white dark:bg-dark-800 w-5/6 max-w-4xl shadow-md rounded-lg dark:shadow-dark-600 transform transition-all duration-300 ease-in-out"
            :class="{
                'animate__animated animate__zoomIn': showModal,
                'animate__animated animate__zoomOut': !showModal,
            }">
            <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Filter Transaksi</h5>
            </div>
            <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
                <div class="flex flex-col gap-2">
                    <label class="font-medium text-dark-600 dark:text-dark-400">Range Tanggal</label>
                    <DatePicker v-model="rangeDate" selectionMode="range" :manualInput="false" />
                </div>
                <InputSelect v-model="selectedMarketingId" label="Staff" id="filter-staff" :options="allMarketings"
                    placeholder="Pilih staff" optionLabel="name" optionValue="id"
                    :virtual-scroller-options="{ itemSize: 38 }" :is-scrolled="allMarketings.length > 10" />
                <InputSelect v-model="selectedPaymentMethodId" label="Metode Pembayaran" id="filter-payment-method"
                    :options="allPaymentMethods" placeholder="Pilih metode pembayaran" optionLabel="name"
                    optionValue="id" />
                <div class="flex flex-col gap-2">
                    <label class="font-medium text-dark-600 dark:text-dark-400">Cash Register</label>
                    <div class="flex gap-2">
                        <label
                            class="flex-1 border border-gray-300 bg-gray-50 p-2 rounded-md h-15 font-medium text-dark-600 dark:text-dark-400">{{
                                formatCashRegisterTime(this.allCashRegisters.find(cashRegister => cashRegister.id ===
                                    this.selectedCashRegisterId)) || 'Pilih Cash Register' }}</label>
                        <Button icon="pi pi-search" class="w-10 h-10" @click="showModalCashRegister" />
                    </div>
                </div>
                <InputSelect v-model="selectedGlobalDiscountId" label="Global Discount" id="filter-global-discount"
                    :options="allGlobalDiscounts" placeholder="Pilih global discount" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedItemCategoryId" label="Kategori Item" id="filter-item-category"
                    :options="allItemCategories" placeholder="Pilih item category" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedStatus" label="Status" id="filter-status" :options="allStatuses"
                    placeholder="Pilih status" optionLabel="name" optionValue="id" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Filter"
                        button_class="mx-1 bg-primary hover:bg-hover-primary text-white" @click="submitFilter" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import { mapGetters } from 'vuex';
    import InputSelect from '@/components/form/InputSelect.vue';
    import { DatePicker, Button, ConfirmDialog } from 'primevue';
    import { formatTime } from '@/helpers/formatTime';
    import ModalChooseCashRegister from '@/components/modals/ModalChooseCashRegister.vue';

    export default {
        name: "ModalFilterTable",
        props: {
            filter: {
                type: Object,
                default: null,
            }
        },
        components: {
            SubmitButton, InputSelect, DatePicker, Button, ConfirmDialog, ModalChooseCashRegister
        },
        computed: {
            ...mapGetters('marketings', ['allMarketings']),
            ...mapGetters('tables', ['allTables']),
            ...mapGetters('cash_registers', ['allCashRegisters']),
            ...mapGetters('payment_methods', ['allPaymentMethods']),
            ...mapGetters('global_discounts', ['allGlobalDiscounts']),
            ...mapGetters('item_categories', ['allItemCategories']),
            ...mapGetters('customers', ['allCustomers']),
            optionCashRegister() {
                return this.allCashRegisters.map((cashRegister) => {
                    return {
                        name: `${formatTime(cashRegister.time_start)} - ${formatTime(cashRegister.time_end)}`,
                        id: cashRegister.id,
                    };
                });
            },
        },
        watch: {
            filter: {
                immediate: true,
                handler(newVal) {
                    console.log(newVal);
                    this.rangeDate = newVal.rangeDate;
                    this.selectedType = newVal.type;
                    this.selectedStatus = newVal.status;
                    this.selectedTableId = newVal.table_id;
                    this.selectedMarketingId = newVal.marketing_id;
                    this.selectedPaymentMethodId = newVal.payment_method_id;
                    this.selectedItemCategoryId = newVal.item_category_id;
                    this.selectedGlobalDiscountId = newVal.global_discount_id;
                    this.selectedCashRegisterId = newVal.cash_register_id;
                }
            }
        },
        async created() {
            try {
                // Fetch required data in parallel
                await Promise.all([
                    this.$store.dispatch("tables/fetchTables", { limit: 1000 }),
                    this.$store.dispatch("payment_methods/fetchPaymentMethods", { limit: 1000 }),
                    this.$store.dispatch("marketings/fetchMarketings", { limit: 1000 }),
                    this.$store.dispatch("cash_registers/fetchCashRegisters", { limit: 1000 }),
                    this.$store.dispatch("global_discounts/fetchGlobalDiscounts", { limit: 1000 }),
                    this.$store.dispatch("item_categories/fetchItemCategories", { limit: 1000 }),
                    this.$store.dispatch("customers/fetchCustomers", { limit: 1000 }),
                ]);
                this.optionCustomers = this.allCustomers.map(customer => ({ label: customer.fullname, value: customer.id }));
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                this.errorMessage =
                    error.message ||
                    "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
                this.showErrorDialog = true;
                this.isLoading = false;
            }
            this.rangeDate = this.filter.rangeDate;
            this.selectedType = this.filter.type;
            this.selectedStatus = this.filter.status;
            this.selectedTableId = this.filter.table_id;
            this.selectedMarketingId = this.filter.marketing_id;
            this.selectedPaymentMethodId = this.filter.payment_method_id;
            this.selectedItemCategoryId = this.filter.item_category_id;
            this.selectedGlobalDiscountId = this.filter.global_discount_id;
            this.selectedCashRegisterId = this.filter.cash_register_id;
        },
        data() {
            return {
                showModal: true,
                selectedType: '',
                rangeDate: null,
                allTypes: [
                    { id: 'dine_in', name: 'Dine In' },
                    { id: 'take_away', name: 'Take Away' },
                    { id: 'staff', name: 'Staff' },
                ],
                selectedStatus: '',
                allStatuses: [
                    { id: 'paid', name: 'Paid' },
                    { id: 'pending', name: 'Pending' },
                    { id: 'cancelled', name: 'Cancelled' },
                ],
                filterCapacity: '',
                selectedTableId: '',
                selectedMarketingId: '',
                selectedPaymentMethodId: '',
                selectedItemCategoryId: '',
                selectedGlobalDiscountId: '',
                selectedCashRegisterId: '',
                modalShowFilterTransaction: false,
                modalShowCashRegister: false,
                isBlur: false,
            }
        },
        methods: {
            formatTime,
            formatCashRegisterTime(cashRegister) {
                if (!cashRegister) return '';
                return `${formatTime(cashRegister.time_start)} - ${formatTime(cashRegister.time_end)}`;
            },
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('closeModal');
                }, 200);
            },
            submitFilter() {
                this.$emit('submitFilter', {
                    rangeDate: this.rangeDate,
                    type: this.selectedType,
                    status: this.selectedStatus,
                    table_id: this.selectedTableId,
                    marketing_id: this.selectedMarketingId,
                    payment_method_id: this.selectedPaymentMethodId,
                    item_category_id: this.selectedItemCategoryId,
                    global_discount_id: this.selectedGlobalDiscountId,
                    cash_register_id: this.selectedCashRegisterId,
                });
                this.closeModal();
            },
            showModalCashRegister() {
                this.modalShowCashRegister = true;
                this.isBlur = true;
            },
            closeModalCashRegister() {
                setTimeout(() => {
                    this.modalShowCashRegister = false;
                    this.isBlur = false;
                }, 200);
            },
            selectCashRegister(cashRegister) {
                this.selectedCashRegisterId = cashRegister.id;
                this.closeModalCashRegister();
            },
            resetFilter() {
                this.rangeDate = null;
                this.selectedType = '';
                this.selectedStatus = '';
                this.selectedTableId = '';
                this.selectedMarketingId = '';
                this.selectedPaymentMethodId = '';
                this.selectedItemCategoryId = '';
                this.selectedGlobalDiscountId = '';
                this.selectedCashRegisterId = '';
                this.selectedCustomerId = '';
            },
        }
    }
</script>